// @flow
import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames/bind';
import { withTranslation } from 'react-i18next';
import IconEntry from 'app/common/icons/IconEntry';

import styles from './CardPassages.scss';
import MoreLink from '../MoreLink';


type Props = {
  items: Array<Object>,
  count: number,
  link: string,
  appString: string,
  className: string,
  t: (s: string) => string,
}

const CardPassages = ({ items, count, link, appString, className, t }: Props) => (
  <div className={classNames(styles.root, className)}>
    {items[0] && items[0].text
      && <div className={styles.item}>
        <div>
          {items[0].text}
        </div>
        {items[0].comment && <div className={styles.comment}>{items[0].comment}</div>}
      </div>}

    {items[1] && items[1].text
      && <div className={styles.item}>
        <div>
          {items[1].text}
        </div>
        {items[1].comment && <div className={styles.comment}>{items[1].comment}</div>}
      </div>}

    {count > 3
      && <div className={styles.linkBlock}>
        <span>{appString}</span>
        <Link to={link} className={styles.link}>{t('open_in_app')}</Link>
      </div>}

    {items[2] && items[2].text
      && <div className={styles.item}>
        <div>
          {items[2].text}
        </div>
        {items[2].comment && <div className={styles.comment}>{items[2].comment}</div>}
      </div>}

    <Link to={link} className={styles.icon}><IconEntry /></Link>
    <MoreLink to={link} />
  </div>
);

export default withTranslation('children')(CardPassages);
